export type ViewType = 'ALL' | 'GENERAL' | 'PROGRAMMER';

export const JobGroupGeneralCodeList = [1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12];
export const JobGroupProgrammerCodeList = [13];
